module.exports = __webpack_public_path__ + "img/1-04.4bd5920f.png";